<template>
	<div v-if="user.subscription">

		<delivery-main :editable="['address']">

			<template v-slot:cta-global v-if="$mq.isDesktop()">
		        <flash
		          :flash="flash"
		          :state="state"
		          class="mr-5"
		        />
				<CTA
	      			:loading="updating"
					:disabled="!shipmentZonesStore.shipmentZones.available.length > 0 || updating"
					@click="stepSubscription()"
					:content="`Salva`"
				/>
			</template>
	      	<template v-slot:cta v-if="!$mq.isDesktop()">
		        <flash
		          :flash="flash"
		          :state="state"
		          class="mr-5"
		        />
		        <CTA
		          :loading="updating"
		          :disabled="!shipmentZonesStore.shipmentZones.available.length > 0 || updating"
		          @click="stepSubscription()"
		          :content="`Salva`"
		        />
		    </template>

		</delivery-main>

		<general-error />
	</div>
</template>

<script>
import { scrollToElementId } from '../../assets/js/main'
import CheckoutChangeMenu from './CheckoutChangeMenu'

import { deliveryContainer } from '../../mixins/deliveryContainer'
import { dates } from '../../mixins/dates'

import DeliveryMain from '../Delivery/DeliveryMain'
import GeneralError from '../Checkout/GeneralError'
import Flash from '../Parts/Flash'

import { subscriptionStore } from '../../store/subscriptionStore'
import { orderStore } from '../../store/orderStore'
import { errorStore } from '../../store/errorStore'
import { stepStore } from '../../store/stepStore'

import { Subscription } from '../../core/Subscription'
import { Order } from '../../core/Order'
import { User } from '../../core/User'

export default {
	watch: {
		'subscriptionStore.subscriptionParams': {
            handler: function () {
                errorStore.removeMessage()
            },
            deep: true
        }
	},

	mixins: [	
		deliveryContainer,
		dates
	],

	components: {
    CheckoutChangeMenu,
		DeliveryMain,
		GeneralError,
		Flash
	},

	data () {
		return {
			subscriptionStore: subscriptionStore.state,
			orderStore: orderStore.state,
			errorStore: errorStore.state,
			stepStore: stepStore.state,
      checkChangeMenu: false,
			flash: null,
			state: null
		}
	},

	computed: {
		user () {
			return this.$root.user
		},
		updating () {
			return this.stepStore.updating['subscription']
		}
	},

	methods: {
        updateUserView () {
        	var user = this.user
			user.subscription = this.subscriptionStore.subscription
			user.order = this.orderStore.order
			this.$root.updateUser(user)
        },	

        showFlash (params) {
			this.flash = params.flash
			this.state = params.state

			setTimeout(() => {
				this.flash = null
			}, 2000)
		},

		stepSubscription () {
      window.dispatchEvent(new CustomEvent('checkout-change-menu', { 
        bubbles: true,
        detail: this.stepAfterConfirmationSubscription
      }));
    },

    stepAfterConfirmationSubscription() {
			this.showFlash({
				flash: null	
			})

			errorStore.removeMessage()

				return stepStore.stepSubscription()
      .then(response => {
        if (!orderStore.state.order) return Promise.resolve()

        return orderStore.updateOrder()
      }).then(response => {
				if (!orderStore.state.order) return Promise.resolve()
				return orderStore.notifyOrder()
			})

			.then(response => {
				stepStore.state.updating.subscription = false

				this.updateUserView()
				this.showFlash({
					flash: '<i class="fas fa-check"></i> Modifiche applicate',
					state: 'success'	
				})

				this.$nextTick(() => {
 	 				scrollToElementId('delivery')
    		})
			})

			.catch(response => {
				stepStore.state.updating.subscription = false
				errorStore.formatMessage(response)
			})
		},

		afterSelect () {
			// do nothing
		}
	},

	mounted () {
		if (!this.user.subscription) return

		orderStore.state.order = (this.user && this.user.order) ? new Order(this.user.order) : null
		subscriptionStore.state.subscription = this.user.subscription

		this.$_deliveryContainer_fillSubscriptionParams()
	}
}

</script>

<style scoped>
* >>> .form,
.delivery-list {
	max-width: 700px;
}

label {
	min-width: 300px;
}

* >>> .flash {
	margin-left: 10px;
}
</style>
